import { render, staticRenderFns } from "./OrganizationManagement.vue?vue&type=template&id=1dc12220&scoped=true"
import script from "./OrganizationManagement.vue?vue&type=script&lang=js"
export * from "./OrganizationManagement.vue?vue&type=script&lang=js"
import style0 from "./OrganizationManagement.vue?vue&type=style&index=0&id=1dc12220&prod&lang=scss&scoped=true"
import style1 from "./OrganizationManagement.vue?vue&type=style&index=1&id=1dc12220&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc12220",
  null
  
)

export default component.exports